export default __webpack_public_path__ + "static/bg_top_waves_dark-cc931888460323712aedc4df3d7369d6.svg";